import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postInventoryPhase2 } from '../Api'

export default generateApiAction({
  baseType: Types.INVENTORIES.POST.P2,
  api: postInventoryPhase2,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/inventories/PostPhase2Action.js